<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-if="stock.id !== undefined"
          label="ID"
          v-model="stock.id"
          disabled
        >
        </v-text-field>

        <v-text-field
          label="Cantitate"
          v-model="stock.quantity"
          :rules="requiredNumberRules"
          required
        >
        </v-text-field>

        <v-text-field
          label="Factura de achizitie"
          v-model="stock.invoiceBuyNumber"
        ></v-text-field>

        <v-menu
          ref="menuDate"
          v-model="menuDate"
          :close-on-content-click="false"
          :return-value.sync="stock.date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="stock.date"
              label="Data achizitie"
              prepend-icon="event"
              readonly
              v-on="on"
              :rules="requiredRule"
            ></v-text-field>
          </template>
          <v-date-picker v-model="stock.date" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuDate = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.menuDate.save(stock.date)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['stock', 'onSubmit'],
  data() {
    return {
      valid: true,
      menuDate: false,
      requiredNumberRules: [
        (v) => !!v || isNaN(Number(v)) || 'Campul trebuie completat.',
      ],
      requiredRule: [(v) => !!v || 'Campul trebuie completat.'],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
